// Application Classes
// Application Constants
import { environment } from '@environments/environment';

// Application Classes
import { QueryStringParameters } from './query-string-parameters';
import { UrlBuilder } from './url-builder';

export class ApiBuilder {
    /* #region URL CREATOR */
    // URL
    public static createUrl(action: string): string {
        const urlBuilder: UrlBuilder = new UrlBuilder(environment.apiUrl, action);
        return urlBuilder.toString();
    }

    // URL WITH QUERY PARAMS
    public static createUrlWithQueryParameters(action: string, queryStringHandler?: (queryStringParameters: QueryStringParameters) => void): string {
        const urlBuilder: UrlBuilder = new UrlBuilder(environment.apiUrl, action);
        // Push extra query string params
        if (queryStringHandler) {
            queryStringHandler(urlBuilder.queryString);
        }
        return urlBuilder.toString();
    }

    // URL WITH PATH VARIABLES
    public static createUrlWithPathVariables(action: string, pathVariables: any[] = []): string {
        let encodedPathVariablesUrl = '';
        // Push extra path variables
        for (const pathVariable of pathVariables) {
            if (pathVariable !== null) {
                encodedPathVariablesUrl += `/${encodeURIComponent(pathVariable.toString())}`;
            }
        }
        const urlBuilder: UrlBuilder = new UrlBuilder(environment.apiUrl, `${action}${encodedPathVariablesUrl}`);
        return urlBuilder.toString();
    }

    /* #endregion */
}
